export default __webpack_public_path__ + "static/media/YarnIcon.63eeb366.png";